import { FC } from "react";
import { TextPage } from "../contactUpdateInquiries/TextPage";

interface Props {
	headline: string;
	text: string;
}

export const ContactUpdateInquiriesDefaultEndPage: FC<Props> = ({ headline, text }) => {
	return <TextPage headline={headline} text={text}></TextPage>;
};
